import React, { useEffect, useState } from 'react';
import { Col, Row } from 'reactstrap';
import useAxios from 'hooks/useAxios';
import { dateFormate, cellRendererCheck } from 'utils/columns';

const EncounterComment = ({ encounterID, tenantID }) => {
  const API = useAxios();
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchEncounterClaimComments();
  }, []);
  const fetchEncounterClaimComments = async () => {
    try {
      const { data } = await API.get(
        `/${tenantID}/ceservicelocation/getbyencounter/${encounterID}`,
        {
          hideLoader: true,
        }
      );
      setLoading(false);
      setData(data);
    } catch (error) {
      setLoading(false);
    }
  };
  return (
    <>
      <Row className='' style={{ borderLeft: "1px solid #9E9E9E", paddingLeft: "15px", }}>
        <Col md={12}>
          <p className='f-14 mb-0 font-weight-500'>
            Service Location Comments:
            <b className='d-block font-weight-500'>
              {data.comments || '-'}
            </b>
          </p>
        </Col>

        <Col md={12}>
          <Row className='align-items-center mt-2'>
            <Col md='6' className=''>
              <p className='f-14 mb-0'>
                Modified Date:
                <b className='d-block font-weight-500'>
                  {dateFormate(data.modifiedDate)}
                </b>
              </p>

            </Col>
            <Col md='6' className=''>
              <p className='f-14 mb-0'>
                Modified By:
                <b className='d-block font-weight-500'>
                  {cellRendererCheck(data.modifiedBy)}
                </b>
              </p>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default EncounterComment;
